import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {ControlRef} from '@aviary/forms/fields/form-fields.types';
import {getExtendedControlFrom} from '@aviary/forms/form.helpers';
import {ExtendedFormGroup} from '@aviary/forms/extensions/extended-form-group/extended-form-group';
import {ExtendedFormControl} from '@aviary/forms/extensions/extended-form-control/extended-form-control';
import {BaseFormFieldComponent} from '@aviary/forms/fields/base-form-field/base-form-field.component';
import {MatInput} from '@angular/material/input';
import {NgClass} from '@angular/common';
import {ReactiveFormsModule} from '@angular/forms';
import {provideControlRefTokenFor} from '@aviary/providers/control-ref.provider';

@Component({
  selector: 'mx-textarea-form-field',
  template: `
    <mx-base-form-field [fieldName]="fieldName" [overrideLabel]="overrideLabel" [formGroup]="formGroup" [control]="control"
                        [ngClass]="{ 'pointer-events-none': readonly }">
      <!-- The minimum height style is used when the user resizes the box -- at a minimum, the <textarea>'s height matches the height of a standard input. -->
      <textarea matInput [formControl]="control" [placeholder]="placeholder" rows="{{ initialRows }}" [readonly]="readonly"
                class="w-full min-h-[1.5rem] me-2 read-only:resize-none read-only:overflow-hidden">
      </textarea>
    </mx-base-form-field>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [provideControlRefTokenFor(TextareaFormFieldComponent)],
  imports: [BaseFormFieldComponent, MatInput, NgClass, ReactiveFormsModule],
})
export class TextareaFormFieldComponent implements OnInit, ControlRef {

  @Input() public fieldName: string;
  @Input() public overrideLabel?: string;
  @Input() public placeholder = '';
  @Input() public initialRows = 4;
  @Input() public formGroup: ExtendedFormGroup;
  @Input() public readonly: boolean = false;

  public control: ExtendedFormControl;  // It's tempting to rename this to "formControl", but that's a reserved name and causes confusing errors.  So don't.

  public ngOnInit(): void {
    this.control = getExtendedControlFrom(this.formGroup, this.fieldName);
  }
}
